import React from "react";

import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import VisibilityIcon from "@mui/icons-material/Visibility";

import { GroupAdminInfo } from "../../api/groups";
import { useGroupsStore } from "../../store/groupsStore";
import { useDialogState } from "../../hooks/useDialogState";
import { InfinitePaginationTable } from "../common/InfinitePaginationTable";
import { GroupDetailDialog } from "./GroupDetailDialog";

export const GroupList = () => {
  const { groups, loading, loadGroups } = useGroupsStore();
  const detailDialog = useDialogState<GroupAdminInfo>();

  React.useEffect(() => {
    loadGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    { id: "name", label: "Name" },
    {
      id: "tag",
      label: "Tag",
      render: (group: GroupAdminInfo) => (
        <Typography variant="body2" sx={{ fontFamily: "monospace" }}>
          #{group.tag}
        </Typography>
      ),
    },
    {
      id: "members",
      label: "Members",
      render: (group: GroupAdminInfo) => (
        <Typography variant="body2">{group.members.length}</Typography>
      ),
    },
    {
      id: "actions",
      label: "Actions",
      render: (group: GroupAdminInfo) => (
        <Tooltip title="View details">
          <IconButton
            size="small"
            onClick={() => detailDialog.openWith(group)}
            sx={{ color: "#1976d2" }}
          >
            <VisibilityIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  const sortedGroups = [...groups].sort((a, b) => a.name.localeCompare(b.name));

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <InfinitePaginationTable
        columns={columns}
        items={sortedGroups}
        pageSize={10}
        loading={loading}
        onLoadNext={() => {}}
      />
      <GroupDetailDialog
        open={detailDialog.open}
        group={detailDialog.data}
        onClose={detailDialog.close}
      />
    </Box>
  );
};
